"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ClickOutsideListener = _interopRequireDefault(require("./components/ClickOutsideListener"));
require("./SpeedSelect.scss");
var _excluded = ["innerRef", "style", "isMultiple", "disableSearch", "inputRef", "searchPlaceholder", "inputSearch", "handleSearch", "keyboardHandler"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SpeedSelect = /*#__PURE__*/function (_Component) {
  _inherits(SpeedSelect, _Component);
  var _super = _createSuper(SpeedSelect);
  function SpeedSelect(props) {
    var _this;
    _classCallCheck(this, SpeedSelect);
    _this = _super.call(this, props);
    _this.validateProps(props);
    _this.state = _this.giveState(props);
    _this.dropDownRef = /*#__PURE__*/_react["default"].createRef();
    _this.selectBoxRef = /*#__PURE__*/_react["default"].createRef();
    _this.searchInputRef = /*#__PURE__*/_react["default"].createRef();
    _this.dropDownPositionStyles = {
      top: 'calc(100% + 6px)',
      bottom: null,
      left: _this.props.dropdownAlignment !== 'right' ? '0px' : 'auto',
      right: _this.props.dropdownAlignment === 'right' ? '0px' : 'auto'
    };
    _this.closeDropdown = _this.closeDropdown.bind(_assertThisInitialized(_this));
    _this.handleOptionClick = _this.handleOptionClick.bind(_assertThisInitialized(_this));
    _this.handleOptionRemove = _this.handleOptionRemove.bind(_assertThisInitialized(_this));
    _this.handleSelectBoxClick = _this.handleSelectBoxClick.bind(_assertThisInitialized(_this));
    _this.handleKeyBoardEvents = _this.handleKeyBoardEvents.bind(_assertThisInitialized(_this));
    _this.handleDropdownOutsideClick = _this.handleDropdownOutsideClick.bind(_assertThisInitialized(_this));
    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_this));
    _this.handleSelectOpen = _this.handleSelectOpen.bind(_assertThisInitialized(_this)); //Open dropdown on label click
    return _this;
  }
  _createClass(SpeedSelect, [{
    key: "validateProps",
    value: function validateProps(props) {
      // validate required props here before doing anything
      if (!Array.isArray(props.options)) {
        throw Error('options prop must be an \'Array\'');
      }
      var optionType = _typeof(props.options[0]);
      if (optionType === 'object') {
        if (!props.displayKey || !props.uniqueKey) {
          throw Error('Both displayKey and uniqueKey props must be provided when options is an \'Object Array\'');
        }
      }
      // validate selectedOptions type in case of multiple
      if (Object.prototype.hasOwnProperty.call(props, 'multiple') && !Array.isArray(props.selectedOption)) {
        throw Error('selectedOption prop must be an \'Array\' in case multiple prop is present');
      }
    }
  }, {
    key: "giveState",
    value: function giveState(props) {
      return {
        isOpen: false,
        optionsCopy: props.options,
        inputSearch: '',
        keyboardSelectedIndex: null,
        // stores the index of currently selected item using keyup and keydown keys
        // keyboardEnterPressedOnItem: false, // used to trigger the selection of the keyboard selected item
        checkedOptions: props.selectedOption,
        // used only in case of multiple select
        isMultiple: Object.prototype.hasOwnProperty.call(props, 'multiple')
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.options !== this.props.options) {
        this.validateProps(this.props);
        this.setState(this.giveState(this.props));
      }
    }
  }, {
    key: "handleSelectBoxClick",
    value: function handleSelectBoxClick(e) {
      var _this2 = this;
      e.stopPropagation();
      // ignore the click until options are available
      if (!this.props.options.length) return;
      this.setState(_objectSpread(_objectSpread({}, this.giveState(this.props)), {}, {
        isOpen: true
      }), function () {
        if (!_this2.state.isOpen) {
          // since handleSelectBox is also called when user press the select box to close the opened dropdown
          // hence in this case dropdown is not available (this.dropDownRef will be 'null'), no need to recompute the styles 
          // Do check that if dropdown is open or not before doing anything
          return;
        }

        //to handle sub header z-index only
        setTimeout(function () {
          if (_this2.props.onDropDownOpen) {
            _this2.props.onDropDownOpen(_this2.state.isOpen);
          }
        }, 10);
        _this2.searchInputRef.current && _this2.searchInputRef.current.focus();

        // dropDown's height  is available now, do required computations here
        var selectBoxRect = _this2.selectBoxRef.current.getBoundingClientRect();
        // decide vertical position 
        var windowHeight = window.innerHeight;
        var dropDownHeight = _this2.dropDownRef.current.clientHeight;
        var selectBoxBottomPos = selectBoxRect.bottom;
        var selectBoxTopPos = selectBoxRect.top;
        var isHieghtBelowEnough = windowHeight - selectBoxBottomPos > dropDownHeight + 35; /** 35 is the gap btwn select box and dropdown*/
        var isHieghtAboveEnough = selectBoxTopPos > dropDownHeight + 35;
        if (isHieghtBelowEnough || !isHieghtAboveEnough) {
          // remaining height is more than enough,  show dropdown below the select-box
          if (_this2.dropDownPositionStyles.top) {
            // do nothing if already below
            // this is to avoid re-render
            return;
          }
          _this2.dropDownPositionStyles = {
            top: 'calc(100% + 6px)',
            bottom: null
          };
          _this2.forceUpdate();
        } else {
          // remaining height is less than enough,  show dropdown above the select-box
          if (_this2.dropDownPositionStyles.bottom) {
            // do nothing if alrady above
            return;
          }
          _this2.dropDownPositionStyles = {
            top: null,
            bottom: 'calc(100% + 6px)'
          };
          _this2.forceUpdate();
        }
      });
    }
  }, {
    key: "handleKeyBoardEvents",
    value: function handleKeyBoardEvents(e) {
      // console.log('keyboard event on select box called...', e.eventPhase, e.defaultPrevented);
      e.stopPropagation();
      // do not call preventDefault(), calling this will prevent the onChange event to be executed on search input
      switch (e.key) {
        case 'Enter':
          if (!this.state.isOpen) {
            // console.log('opening on enter btn');
            this.handleSelectBoxClick(e);
            return;
          }
          if (this.state.keyboardSelectedIndex !== null) {
            var currentOption = this.state.optionsCopy[this.state.keyboardSelectedIndex];
            // this.setState({ keyboardEnterPressedOnItem: true });
            if (this.state.isMultiple) {
              var isOptionObject = _typeof(this.props.options[0]) === 'object';
              var uniqueKey = this.props.uniqueKey;
              var isChecked = isOptionObject ? this.state.checkedOptions.some(function (co) {
                return co[uniqueKey] === currentOption[uniqueKey];
              }) : this.state.checkedOptions.includes(currentOption);
              this.handleOptionClickMultiple(currentOption, !isChecked);
            } else {
              this.handleOptionClickSingle(currentOption);
            }
          }
          break;
        case 'ArrowDown':
          if (!this.state.isOpen) {
            // console.log('opening on ArrowDown btn');
            this.handleSelectBoxClick(e);
            return;
          }
          // TODO : FIND NEXT SELECTABLE OPTION
          this.setState({
            keyboardSelectedIndex: this.giveNextKeyboardSelectableIndex(e.key)
          });
          break;
        case 'ArrowUp':
          this.setState({
            keyboardSelectedIndex: this.giveNextKeyboardSelectableIndex(e.key)
          });
          break;
        case 'Tab':
          if (this.state.isOpen && (!this.state.isMultiple || this.props.hideOkCancelBtns)) {
            this.closeDropdown();
            return;
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: "giveNextKeyboardSelectableIndex",
    value: function giveNextKeyboardSelectableIndex(key) {
      var _this3 = this;
      if (key === 'ArrowDown') {
        if (this.state.keyboardSelectedIndex === this.state.optionsCopy.length - 1) {
          // can't go beyond this, hence return the exisitng one
          return this.state.keyboardSelectedIndex;
        }

        // find next selectable(not disabled) index  starting from startIndex and moving downwards
        var startIndex = this.state.keyboardSelectedIndex === null ? 0 : this.state.keyboardSelectedIndex + 1;
        var nextIndex = null;
        var _loop = function _loop() {
          var op = _this3.state.optionsCopy[i];
          var _this3$props = _this3.props,
            _this3$props$disabled = _this3$props.disabledOptions,
            disabledOptions = _this3$props$disabled === void 0 ? [] : _this3$props$disabled,
            uniqueKey = _this3$props.uniqueKey;
          var isOptionObject = _typeof(_this3.props.options[0]) === 'object';
          var isDisabled = isOptionObject ? disabledOptions.some(function (d) {
            return d[uniqueKey] === op[uniqueKey];
          }) : disabledOptions.includes(op);
          if (!isDisabled) {
            nextIndex = i;
            return "break";
          }
        };
        for (var i = startIndex, l = this.state.optionsCopy.length; i < l; i++) {
          var _ret = _loop();
          if (_ret === "break") break;
        }
        if (nextIndex === null) {
          // no next selectable item found, hence return exisiting one
          return this.state.keyboardSelectedIndex;
        }
        return nextIndex;
      } else {
        //  key==='ArrowUp'
        if (this.state.keyboardSelectedIndex === 0) {
          // can't go above this, hence return 0
          return 0;
        }
        if (this.state.keyboardSelectedIndex === null) {
          // no index is selected yet, in this case, find the first index selectable from top
          // it is similar to finding first index when 'ArrowDown' Key is pressed
          return this.giveNextKeyboardSelectableIndex('ArrowDown');
        }

        // find next selectable index starting from startIndex and moving upwards
        var _startIndex = this.state.keyboardSelectedIndex - 1;
        var _nextIndex = null;
        var _loop2 = function _loop2() {
          var op = _this3.state.optionsCopy[_i];
          var _this3$props2 = _this3.props,
            _this3$props2$disable = _this3$props2.disabledOptions,
            disabledOptions = _this3$props2$disable === void 0 ? [] : _this3$props2$disable,
            uniqueKey = _this3$props2.uniqueKey;
          var isOptionObject = _typeof(_this3.props.options[0]) === 'object';
          var isDisabled = isOptionObject ? disabledOptions.some(function (d) {
            return d[uniqueKey] === op[uniqueKey];
          }) : disabledOptions.includes(op);
          if (!isDisabled) {
            _nextIndex = _i;
            return "break";
          }
        };
        for (var _i = _startIndex; _i >= 0; _i--) {
          var _ret2 = _loop2();
          if (_ret2 === "break") break;
        }
        if (_nextIndex === null) {
          return this.state.keyboardSelectedIndex;
        }
        return _nextIndex;
      }
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      var _this4 = this;
      this.setState({
        isOpen: false
      }, function () {
        if (_this4.props.onDropDownOpen) {
          _this4.props.onDropDownOpen(_this4.state.isOpen); //to handle sub header z-index
        }
      });
    }
  }, {
    key: "handleDropdownOutsideClick",
    value: function handleDropdownOutsideClick() {
      this.closeDropdown();
    }
  }, {
    key: "handleOptionClick",
    value: function handleOptionClick(e, op, singleOrMultiple) {
      e.stopPropagation();
      if (singleOrMultiple === 'multiple') {
        this.handleOptionClickMultiple(op, e.target.checked);
      } else {
        this.handleOptionClickSingle(op);
      }
    }
  }, {
    key: "handleOptionClickSingle",
    value: function handleOptionClickSingle(op) {
      // op is the clicked item
      this.props.onSelect(op);
      this.closeDropdown();
    }
  }, {
    key: "handleOptionClickMultiple",
    value: function handleOptionClickMultiple(op, checked) {
      // op indicates what is clicked or pressed
      if (op === 'CANCEL_BTN') {
        // close dropdown, no other action needed
        this.closeDropdown();
      } else if (op === 'OK_BTN') {
        // send the list of checkedOptions to parent component and close dropdown
        this.props.onSelect(this.state.checkedOptions);
        this.closeDropdown();
      } else if (op === 'SELECT_ALL_BTN') {
        var updated;
        var isOptionObject = _typeof(this.props.options[0]) === 'object';
        var _this$props = this.props,
          _this$props$disabledO = _this$props.disabledOptions,
          disabledOptions = _this$props$disabledO === void 0 ? [] : _this$props$disabledO,
          uniqueKey = _this$props.uniqueKey;
        var _this$state = this.state,
          checkedOptions = _this$state.checkedOptions,
          optionsCopy = _this$state.optionsCopy;
        if (checked) {
          // filter out options which are disabled
          updated = optionsCopy.filter(function (oc) {
            return !disabledOptions.some(function (dop) {
              return isOptionObject ? dop[uniqueKey] === oc[uniqueKey] : dop === oc;
            });
          });
          // check if updated contains the current selected ones, if not then add
          checkedOptions.forEach(function (co) {
            var presentAlready = updated.some(function (uo) {
              return isOptionObject ? uo[uniqueKey] === co[uniqueKey] : uo === co;
            });
            if (!presentAlready) {
              updated.push(co);
            }
          });
        } else {
          // filter out all options visible(present in optionsCopy) which are not disabled 
          var optionsCopyNotDisabled = optionsCopy.filter(function (oc) {
            return !disabledOptions.some(function (dop) {
              return isOptionObject ? dop[uniqueKey] === oc[uniqueKey] : dop === oc;
            });
          });
          updated = checkedOptions.filter(function (co) {
            return !optionsCopyNotDisabled.some(function (oc) {
              return isOptionObject ? co[uniqueKey] === oc[uniqueKey] : co === oc;
            });
          });
        }
        this.setState({
          checkedOptions: updated
        });
        if (this.props.hideOkCancelBtns) {
          this.props.onSelect(updated);
        }
      } else {
        // else checkbox of an option has been checked/unchecked
        // here op is the option itself
        // this code will also be executed in case Enter Key is pressed
        var _updated;
        var _checkedOptions = this.state.checkedOptions;
        var _uniqueKey = this.props.uniqueKey;
        var _isOptionObject = _typeof(this.props.options[0]) === 'object';
        if (checked) {
          _updated = [].concat(_toConsumableArray(_checkedOptions), [op]);
        } else {
          var index = _isOptionObject ? _checkedOptions.findIndex(function (co) {
            return co[_uniqueKey] === op[_uniqueKey];
          }) : _checkedOptions.indexOf(op);
          _updated = [].concat(_toConsumableArray(_checkedOptions.slice(0, index)), _toConsumableArray(_checkedOptions.slice(index + 1)));
        }
        this.setState({
          checkedOptions: _updated
        });
        if (this.props.hideOkCancelBtns) {
          this.props.onSelect(_updated);
        }
      }
    }

    /**For handling cross btn in selected option (in both single and multipe select) */
  }, {
    key: "handleOptionRemove",
    value: function handleOptionRemove(e, op, singleOrMultiple) {
      e.stopPropagation();
      if (singleOrMultiple === 'multiple') {
        this.handleOptionClickMultiple(op, false);
      } else {
        this.handleOptionClickSingle(null);
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(e) {
      var value = e.target.value,
        dk = this.props.displayKey,
        isObj = _typeof(this.props.options[0]) === 'object';
      if (value.trim() === '') {
        this.setState({
          optionsCopy: this.props.options,
          inputSearch: value,
          keyboardSelectedIndex: null
        });
        return;
      }
      var filteredOptions = this.props.options.filter(function (op) {
        return isObj ? op[dk].toLowerCase().includes(value.toLowerCase()) : op.toLowerCase().includes(value.toLowerCase());
      });
      this.setState({
        optionsCopy: filteredOptions,
        inputSearch: value,
        keyboardSelectedIndex: null
      });
    }

    //Open select dropdown on label click
  }, {
    key: "handleSelectOpen",
    value: function handleSelectOpen(e) {
      var _this5 = this;
      e.preventDefault();
      if (this.props.isLabelClickable !== undefined && this.props.isLabelClickable) {
        this.setState({
          isOpen: true
        }, function () {
          setTimeout(function () {
            if (_this5.props.onDropDownOpen) {
              _this5.props.onDropDownOpen(_this5.state.isOpen); //to handle sub header z-index
            }
          }, 10);
        });
      } else {
        return false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isOptionObject = _typeof(this.props.options[0]) === 'object';
      var isMultiple = this.state.isMultiple;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'react-select-container' + (isMultiple ? ' multiple' : ' single')
      }, this.props.prominentLabel && /*#__PURE__*/_react["default"].createElement("div", {
        className: 'select-label-wrapper' + (this.state.isOpen ? ' focused' : ''),
        onClick: this.handleSelectOpen
      }, this.props.prominentLabel), /*#__PURE__*/_react["default"].createElement("div", {
        className: "select-box-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.selectBoxRef,
        tabIndex: "0",
        onKeyDown: this.handleKeyBoardEvents,
        className: 'select-box' + (this.state.isOpen ? ' focused' : '') + (this.props.disable ? ' disabled' : ''),
        onClick: this.handleSelectBoxClick
      }, /*#__PURE__*/_react["default"].createElement(SelectBoxLabel, _extends({
        onSelectedOptionRemove: this.handleOptionRemove,
        isOptionObject: isOptionObject
      }, this.props, this.state)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-icon-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", null))), this.state.isOpen && /*#__PURE__*/_react["default"].createElement(_ClickOutsideListener["default"], {
        isOpen: this.state.isOpen,
        onOutsideClick: this.handleDropdownOutsideClick
      }, /*#__PURE__*/_react["default"].createElement(DropDown, _extends({}, this.props, this.state, {
        isOptionObject: isOptionObject,
        innerRef: this.dropDownRef,
        inputRef: this.searchInputRef,
        handleSearch: this.handleSearch,
        keyboardHandler: this.handleKeyBoardEvents,
        style: this.dropDownPositionStyles,
        onOptionClick: this.handleOptionClick
      })))));
    }
  }]);
  return SpeedSelect;
}(_react.Component);
exports["default"] = SpeedSelect;
var selectBoxLabelClickHandler = function selectBoxLabelClickHandler(e) {
  // stop click event to propagating to DOM, otherwise dropdown will close immediatly due to event emitted by <ClickedOutsideListener/>
  e.persist();
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};
var SelectBoxLabel = function SelectBoxLabel(_ref) {
  var selectedOption = _ref.selectedOption,
    optionsCopy = _ref.optionsCopy,
    displayKey = _ref.displayKey,
    selectLabel = _ref.selectLabel,
    showResetBtn = _ref.showResetBtn,
    onSelectedOptionRemove = _ref.onSelectedOptionRemove,
    isMultiple = _ref.isMultiple,
    showSelectionsInChipForm = _ref.showSelectionsInChipForm,
    selectionWrapperMaxHeight = _ref.selectionWrapperMaxHeight,
    hideOkCancelBtns = _ref.hideOkCancelBtns,
    isOptionObject = _ref.isOptionObject;
  showSelectionsInChipForm = showSelectionsInChipForm || false;
  selectionWrapperMaxHeight = selectionWrapperMaxHeight ? selectionWrapperMaxHeight + 'px' : 'auto';

  // in multiple, always show selectLabel with selected count
  if (isMultiple) {
    var allSelected = selectedOption.length === optionsCopy.length;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "label-wrapper multiple",
      title: selectLabel || 'Select'
    }, showSelectionsInChipForm && selectedOption.length ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "selected-options-wrapper",
      style: {
        maxHeight: selectionWrapperMaxHeight
      }
    }, selectedOption.map(function (op, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-option-item",
        key: i
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "selected-option-item-content"
      }, op[displayKey]), hideOkCancelBtns && /*#__PURE__*/_react["default"].createElement("span", {
        className: "selected-option-item-remove",
        onClick: function onClick(e) {
          return onSelectedOptionRemove(e, op, 'multiple');
        }
      }, "x"));
    })) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "label"
    }, selectLabel || 'Select'), selectedOption.length > 0 && /*#__PURE__*/_react["default"].createElement("span", {
      className: "count"
    }, allSelected ? 'All (' + selectedOption.length + ')' : '+' + selectedOption.length));
  }
  // in single, show selected option if available, otherwise show selectLabel
  if (selectedOption) {
    var labelTxt = isOptionObject ? selectedOption[displayKey] : selectedOption;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "label-wrapper",
      title: labelTxt
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "label"
    }, labelTxt), showResetBtn && /*#__PURE__*/_react["default"].createElement("span", {
      className: "remove-btn",
      onClick: function onClick(e) {
        return onSelectedOptionRemove(e, null, 'single');
      }
    }, "X"));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "label-wrapper",
    title: selectLabel || 'Select'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label"
  }, selectLabel || 'Select'));
};
var DropDown = function DropDown(_ref2) {
  var innerRef = _ref2.innerRef,
    style = _ref2.style,
    isMultiple = _ref2.isMultiple,
    disableSearch = _ref2.disableSearch,
    inputRef = _ref2.inputRef,
    searchPlaceholder = _ref2.searchPlaceholder,
    inputSearch = _ref2.inputSearch,
    handleSearch = _ref2.handleSearch,
    keyboardHandler = _ref2.keyboardHandler,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var updated_style = _objectSpread({}, style);
  if (inputSearch.trim() !== '') {
    updated_style['minWidth'] = '160px';
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: innerRef,
    style: updated_style,
    className: 'select-dropdown'
  }, !disableSearch && /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    className: "search",
    placeholder: searchPlaceholder || 'Search',
    value: inputSearch,
    onChange: handleSearch,
    onClick: selectBoxLabelClickHandler,
    onKeyDown: keyboardHandler
  })), isMultiple ? /*#__PURE__*/_react["default"].createElement(MultipleDropDown, _extends({
    inputSearch: inputSearch
  }, rest)) : /*#__PURE__*/_react["default"].createElement(SingleDropDown, _extends({
    inputSearch: inputSearch
  }, rest)));
};
var MultipleDropDown = function MultipleDropDown(_ref3) {
  var _ref4;
  var optionsCopy = _ref3.optionsCopy,
    checkedOptions = _ref3.checkedOptions,
    _ref3$disabledOptions = _ref3.disabledOptions,
    disabledOptions = _ref3$disabledOptions === void 0 ? [] : _ref3$disabledOptions,
    hideOkCancelBtns = _ref3.hideOkCancelBtns,
    displayKey = _ref3.displayKey,
    uniqueKey = _ref3.uniqueKey,
    imgKey = _ref3.imgKey,
    onOptionClick = _ref3.onOptionClick,
    isOptionObject = _ref3.isOptionObject,
    inputSearch = _ref3.inputSearch,
    createNewOptionWhenNotMatched = _ref3.createNewOptionWhenNotMatched,
    keyboardSelectedIndex = _ref3.keyboardSelectedIndex,
    maxSelectionLimit = _ref3.maxSelectionLimit,
    maxHeight = _ref3.maxHeight;
  maxSelectionLimit = maxSelectionLimit || null;
  var allSelected = false;
  if (optionsCopy.length !== 0) {
    // filter out the disabled ones from the visible ones
    var visibleEnabled = optionsCopy.filter(function (oc) {
      return !disabledOptions.some(function (dop) {
        return isOptionObject ? dop[uniqueKey] === oc[uniqueKey] : dop === oc;
      });
    });
    // check if each option in visibleEnabled is selected or not
    if (visibleEnabled.length && visibleEnabled.every(function (oc) {
      return checkedOptions.some(function (co) {
        return isOptionObject ? co[uniqueKey] === oc[uniqueKey] : co === oc;
      });
    })) {
      allSelected = true;
    }
    // console.log('visibleeEnabled',visibleEnabled,allSelected);
  }

  maxHeight = maxHeight ? maxHeight + 'px' : '450px';
  var handleOKBtnKeyboard = function handleOKBtnKeyboard(e) {
    if (e.key === 'Enter') {
      // on Enter key, do same as on click event
      onOptionClick(e, 'OK_BTN', 'multiple');
    }
  };
  var handleCANCELBtnKeyboard = function handleCANCELBtnKeyboard(e) {
    if (e.key === 'Enter' || e.key === 'Tab') {
      // on Enter or Tab key, do same as on click event
      onOptionClick(e, 'CANCEL_BTN', 'multiple');
    }
  };
  var newOptionToCreate = createNewOptionWhenNotMatched ? isOptionObject ? (_ref4 = {}, _defineProperty(_ref4, uniqueKey, 'NEW_' + inputSearch.trim().toUpperCase()), _defineProperty(_ref4, displayKey, inputSearch.trim()), _ref4) : inputSearch.trim() : null;
  var isMaxSelectionLimitDone = checkedOptions.length === maxSelectionLimit;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "options-with-btns"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'select-all' + (optionsCopy.length === 0 || maxSelectionLimit ? ' disabled' : '')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "select-all",
    className: 'checkbox-wrapper ' + (allSelected ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "chkbox"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: "select-all",
    type: "checkbox",
    tabIndex: "-1",
    checked: allSelected,
    onChange: function onChange(e) {
      return onOptionClick(e, 'SELECT_ALL_BTN', 'multiple');
    }
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "chkbox-label"
  }, 'Select All' + (inputSearch.trim() !== '' ? ' (Filtered)' : '')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "options-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'options' + (imgKey ? ' options-with-img' : ''),
    style: {
      maxHeight: maxHeight
    }
  }, optionsCopy.map(function (op, index) {
    var isSelected = isOptionObject ? checkedOptions.some(function (co) {
      return co[uniqueKey] === op[uniqueKey];
    }) : checkedOptions.includes(op);
    var isDisabled = (isOptionObject ? disabledOptions.some(function (dop) {
      return dop[uniqueKey] === op[uniqueKey];
    }) : disabledOptions.includes(op)) || isMaxSelectionLimitDone && !isSelected;
    var isKeyboardSelected = index === keyboardSelectedIndex;
    var label = isOptionObject ? op[displayKey] : op;
    var id = isOptionObject ? op[uniqueKey] : op;
    var imgUrl = isOptionObject ? op[imgKey] : '';
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: isDisabled ? 'disabled' : isKeyboardSelected ? 'keyboard-selected' : null
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: id,
      className: 'checkbox-wrapper ' + (isSelected ? 'checked' : '')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "chkbox"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      id: id,
      type: "checkbox",
      tabIndex: "-1",
      checked: isSelected,
      onChange: function onChange(e) {
        return !isDisabled && onOptionClick(e, op, 'multiple');
      }
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "chkbox-label"
    }, imgKey && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        backgroundImage: "url(".concat(imgUrl, ")")
      },
      className: "option-img"
    }), label)));
  }), !newOptionToCreate && !optionsCopy.length && inputSearch.trim() !== '' && /*#__PURE__*/_react["default"].createElement("li", {
    className: 'no-match'
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "checkbox-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "No match found"))), newOptionToCreate && !optionsCopy.length && inputSearch.trim() !== '' && /*#__PURE__*/_react["default"].createElement("li", {
    className: 'create-option ' + (0 === keyboardSelectedIndex ? 'keyboard-selected' : '')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: isOptionObject ? newOptionToCreate[uniqueKey] : newOptionToCreate,
    className: 'checkbox-wrapper ' + (checkedOptions.some(function (co) {
      return co[uniqueKey] === newOptionToCreate[uniqueKey];
    }) ? 'checked' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "chkbox"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: isOptionObject ? newOptionToCreate[uniqueKey] : newOptionToCreate,
    type: "checkbox",
    tabIndex: "-1",
    checked: isOptionObject ? checkedOptions.some(function (co) {
      return co[uniqueKey] === newOptionToCreate[uniqueKey];
    }) : checkedOptions.includes(newOptionToCreate),
    onChange: function onChange(e) {
      return onOptionClick(e, newOptionToCreate, 'multiple');
    }
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "chkbox-label"
  }, "Create '" + inputSearch + "'"))))), !hideOkCancelBtns && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ok-cancel-btns"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    role: "button",
    tabIndex: "0",
    onClick: function onClick(e) {
      return onOptionClick(e, 'OK_BTN', 'multiple');
    },
    onKeyDown: handleOKBtnKeyboard
  }, "OK"), /*#__PURE__*/_react["default"].createElement("span", {
    role: "button",
    tabIndex: "0",
    onClick: function onClick(e) {
      return onOptionClick(e, 'CANCEL_BTN', 'multiple');
    },
    onKeyDown: handleCANCELBtnKeyboard
  }, "Cancel")));
};
var SingleDropDown = function SingleDropDown(_ref5) {
  var _ref6;
  var optionsCopy = _ref5.optionsCopy,
    selectedOption = _ref5.selectedOption,
    _ref5$disabledOptions = _ref5.disabledOptions,
    disabledOptions = _ref5$disabledOptions === void 0 ? [] : _ref5$disabledOptions,
    displayKey = _ref5.displayKey,
    uniqueKey = _ref5.uniqueKey,
    imgKey = _ref5.imgKey,
    onOptionClick = _ref5.onOptionClick,
    isOptionObject = _ref5.isOptionObject,
    inputSearch = _ref5.inputSearch,
    createNewOptionWhenNotMatched = _ref5.createNewOptionWhenNotMatched,
    keyboardSelectedIndex = _ref5.keyboardSelectedIndex,
    maxHeight = _ref5.maxHeight;
  selectedOption = selectedOption || {};
  maxHeight = maxHeight ? maxHeight + 'px' : '450px';
  var newOptionToCreate = createNewOptionWhenNotMatched ? isOptionObject ? (_ref6 = {}, _defineProperty(_ref6, uniqueKey, 'NEW_' + inputSearch.trim().toUpperCase()), _defineProperty(_ref6, displayKey, inputSearch.trim()), _ref6) : inputSearch.trim() : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "options-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'options' + (imgKey ? ' options-with-img' : ''),
    style: {
      maxHeight: maxHeight
    }
  }, optionsCopy.map(function (op, index) {
    var isSelected = isOptionObject ? op[uniqueKey] === selectedOption[uniqueKey] : op === selectedOption;
    var isDisabled = isOptionObject ? disabledOptions.some(function (dop) {
      return dop[uniqueKey] === op[uniqueKey];
    }) : disabledOptions.includes(op);
    var isKeyboardSelected = index === keyboardSelectedIndex;
    var label = isOptionObject ? op[displayKey] : op;
    var imgUrl = isOptionObject ? op[imgKey] : '';
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      className: isSelected || isDisabled || isKeyboardSelected ? (isSelected ? ' selected' : '') + (isDisabled ? ' disabled' : '') + (isKeyboardSelected ? ' keyboard-selected' : '') : null,
      onClick: function onClick(e) {
        return !isDisabled && onOptionClick(e, op, 'single');
      }
    }, /*#__PURE__*/_react["default"].createElement("label", null, imgKey && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        backgroundImage: "url(".concat(imgUrl, ")")
      },
      className: "option-img"
    }), /*#__PURE__*/_react["default"].createElement("span", null, label)));
  }), !newOptionToCreate && !optionsCopy.length && inputSearch.trim() !== '' && /*#__PURE__*/_react["default"].createElement("li", {
    className: 'no-match'
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("span", null, "No match found"))), newOptionToCreate && !optionsCopy.length && inputSearch.trim() !== '' && /*#__PURE__*/_react["default"].createElement("li", {
    className: 'create-option',
    onClick: function onClick(e) {
      return onOptionClick(e, newOptionToCreate, 'single');
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("span", null, "Create \u2018", inputSearch.trim(), "\u2019")))));
};